import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false,
    cache:true
};


export default {
    path: '/news',
    name: 'news',
    redirect: {
        name: 'newsList'
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: '/news/newsList',
            name: 'newsList',
            meta: {
                ...meta,
                title: '$t:menu.xwlb',
                desc : '新闻管理'
            },
            component: () => import('@/pages/news/newsList.vue')
        },
        {
            path: '/news/newsEdit/:id',
            name: 'newsEdit',
            meta: {
                ...meta,
                title: '$t:men.newsEdit',
                desc : '编辑新闻'
            },
            component: () => import('@/pages/news/newsEdit.vue')
        },
        {
            path: '/news/newsAdd',
            name: 'newsAdd',
            meta: {
                ...meta,
                title: '$t:men.newsEdit',
                desc : '新增新闻'
            },
            component: () => import('@/pages/news/newsEdit.vue')
        },
        {
            path: '/news/indexNewsList',
            name: 'indexNewsList',
            meta: {
                ...meta,
                title: '$t:men.indexNewsList',
                desc : '新闻列表'
            },
            component: () => import('@/pages/news/indexNewsList.vue')
        },
        {
            path: '/news/indexNewsDetail',
            name: 'indexNewsDetail',
            meta: {
                ...meta,
                title: '$t:men.indexNewsDetail',
                desc : '新闻详情'
            },
            component: () => import('@/pages/news/indexNewsDetail.vue')
        }
    ]
};
